// Libraries
import { Navigate, Routes, Route } from 'react-router-dom';

// Processing
import { useAuth } from 'src/contexts';

// Components
import { MainLayout, NonAuthLayout } from 'src/layouts';
import { DIMainLayout } from 'src/di/layouts';
import { Home, Login, ForgotPassword, Register, School, Search, Help } from 'src/containers';
import { DIHome } from 'src/di/containers/dihome';
import { DISearch } from './di/containers/disearch';
import { FormPage } from './containers/school/FormPage';
import { DIFormPage } from './di/DIFormPage';
import { DIUpdateFormPage } from './di/DIUpdateFormPage';

const AppRoutes = () => {
  const { isLoggedIn, isAdmin, isAI, isDI } = useAuth();

  const AuthedRoutes = (
    <Route path="/" element={<MainLayout isAdmin={isAdmin} />}>
      <Route path="home" element={<Home />} />
      <Route path="school" element={<School />} />
      <Route path="form" element={<FormPage />} />
      {!isAdmin && <Route path="search" element={<Search />} />}
      <Route path="help" element={<Help />} />
      <Route path="/" element={<Navigate to="/school" replace />} />
      <Route path="*" element={<Navigate to="/school" replace />} />
    </Route>
  );

  const DIAuthedRoutes = (
    <Route path="/" element={<DIMainLayout isAdmin={isAdmin} />}>
      <Route path="scoresendcodehome" element={<DIHome />} />
      <Route path="scoresendcodesearch" element={<DISearch />} />
      <Route path="help" element={<Help />} />
      <Route path="/" element={<Navigate to="/scoresendcodehome" replace />} />
      <Route path="*" element={<Navigate to="/scoresendcodehome" replace />} />
      <Route path="diform" element={<DIFormPage />} />
      <Route path="diupdateform" element={<DIUpdateFormPage />} />

    </Route>
  );

  const NonAuthedRoutes = (
    <Route path="/" element={<NonAuthLayout />}>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Route>
  );

  return isAI ? (
    <Routes>{isLoggedIn ? AuthedRoutes : NonAuthedRoutes}</Routes>
  ) : isDI ? (
    <Routes>{isLoggedIn ? DIAuthedRoutes : NonAuthedRoutes}</Routes>
  ) : (
    <Routes>{NonAuthedRoutes}</Routes>
  );
};

export default AppRoutes;
